export const classLoadMoreData = "load-more-data";
